import React, { FC } from 'react';
import styles from './small_title.module.scss';

type Props = {
  title: string;
  subtitle: string;
};

export const SmallTitle: FC<Props> = ({ title, subtitle }) => (
  <div className={styles.container}>
    <h2 className={styles.title}>{title}</h2>
    <div className={styles.subtitle}>{subtitle}</div>
  </div>
);
